<template>
  <input-widget :model="model" :attribute="attribute" :items="statuses" type="select2"
                value-field="key" :label="label" :options="options" :multiple="multiple"
                display-field="${item.text}"/>

</template>

<script>
  import InputWidget from "@/core/components/input-widget/InputWidget";
  import i18n from "@/shared/i18n";

  export default {
    name: "InvoiceStatusSelectInputWidget",
    components: {InputWidget},
    props: {
      model: {
        type: Object,
        required: true,
      },
      attribute: {
        type: String,
        required: true,
      },
      options: {
        type: Object,
        required: false,
        default: () => {
          return {placeholder: i18n.t('Status')}
        }
      },
      multiple: {
        type: Boolean,
        default: false
      },
      label: {
        type: [String, Boolean],
        default: null
      },
      withEmptyStatus: {
        type: Boolean,
        default: false
      },
      removeStatuses: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      statuses() {
        let statuses = [
          {key: 'paid', text: i18n.t('Paid')},
          {key: 'unpaid', text: i18n.t('Unpaid')},
          {key: 'cancelled', text: i18n.t('Cancelled')},
          {key: 'credited', text: i18n.t('Credited')}
        ]

        if (this.withEmptyStatus) {
          statuses.push({key: 'n/a', text: i18n.t('N/A')})
        }

        for (let s of this.removeStatuses) {
          let index = statuses.findIndex(i => i.key === s)
          if (index !== -1) {
            statuses.splice(index, 1)
          }
        }

        return statuses
      }
    }
  }
</script>

<style scoped>

</style>
